import { Aggregator } from 'angular-slickgrid';
import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';

export class MedianAggregator extends SLAggregator {
	private _avg: any = undefined;
	private _count: number;
	protected _name = 'median';
	protected _label = 'Median';
	public groupable = false;
	constructor() {
		super();
	}
	init() {
		super.init();
		this._avg = undefined;
		this._count = 0;
	}
	accumulate(item: any) {
	

	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		if (!totals.group) {
			return;
		}
		if (!totals.group.rows) {
			return;
		}
		const rows = totals.group.rows;
		const count = rows.length;
		this._count = rows.length;
		let lower: number;
		let upper: number;
		let lowerValue: number;
		let upperValue: number;
		if (count === 0) {
			for (const column of this._columns) {
				if (!!this._value[column.id]) {
					delete this._value[column.id];
				}
			}
			super.SetTotals(totals);
			this.EndAggregation(totals, completeHandler);
			return;
		}
		if (count === 1) {
			for (const column of this._columns) {
				this._value[column.id] = Number(rows[0][column.id]);
			}
			super.SetTotals(totals);
			this.EndAggregation(totals, completeHandler);
			return;
		}
		if ((count % 2) === 0) {
			// is even
			lower = count / 2;
			upper = lower + 1;
			for (const column of this._columns) {
				lowerValue = Number(rows[lower][column.id]);
				upperValue = Number(rows[upper][column.id]);
				this._value[column.id] = (lowerValue + upperValue) / 2;
			}
		} else {
			for (const column of this._columns) {
				lower = upper = Math.floor(count / 2);
				this._value[column.id] = Number(rows[lower][column.id]);
			}
		}
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);

	}
}